module.exports = __webpack_public_path__ + "img/header_user_black.effcc0aa.svg";